import axios from 'axios'
import { apiPostValidateOtp } from '@/modules/User/services/authentication'
import router from '@/router'

const API_BASE_URL = process.env.API_HOST || 'http://localhost:8080/'

const publicHttpClient = axios.create({ baseURL: API_BASE_URL })

publicHttpClient.interceptors.response.use(function (response) {
  return Promise.resolve(response.data)
}, async function (error) {
  if (error.response.status === 401) { // refresh token
    if (sessionStorage.getItem('renewToken') === 'false') {
      sessionStorage.setItem('mavAuth', null)
      sessionStorage.setItem('renewToken', 'true')
      const sinisterID = sessionStorage.getItem('sinId')
      const otpCode = sessionStorage.getItem('otpCode')
      const token = await apiPostValidateOtp(sinisterID, otpCode, true)
      if (token) {
        sessionStorage.setItem('mavAuth', `Token ${token.token}`)
        sessionStorage.setItem('renewToken', 'false')
        error.config.headers['Authorization'] = `Token ${token.token}`
        return publicHttpClient.request(error.config)
      }
    }
  } else if (error.status === 403) { // expired token
    if (router) {
      router.replace({ name: 'timedout' })
    }
  }
  return Promise.reject(error)
})

export default publicHttpClient
